<!--
 * @Date: 2020-08-24 09:39:34
 * @Author: MX
 * @LastEditTime: 2021-03-26 15:58:36
 * @Description:
-->
<template>
  <div>
    <el-dialog lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :title="$lang('保价声明')"
      :visible="infoVisible"
      @close="hideDialog"
      width="35%">
      <!-- <div class="tip-box">
        <p class="tips-info">
          1、寄件人对托寄物声明价值并缴纳相应的保价费，当快件在运输途中由于我司原因发生破损、丢失，我司将按照申报价值和货物实际损失比例进行赔偿，赔偿金额不超过快件申报价值。
        </p>
        <p class="tips-info">
          2、价值3000元人民币（含）以上托寄物请选择保价，单件物品申报价值最高不得超出3万元。若未选择保价，则按货物实际损失赔偿，最高赔付3000元人民币。
        </p>
        <p class="tips-info">
          3、保价费用收费标准：托寄物价值3000元以内，保价费用免费，默认最高赔付3000元； 托寄物价值3000元（含）-10000元（含）时，保价费用=托寄物价值*3‰； 托寄物价值10000元-30000元（含）时，保价费用=托寄物价值*5‰。
        </p>
        <p class="tips-info">
          4、合同、发票、证券等无法核定价值的文件类货物不支持投保。
        </p>
      </div> -->
      <p style="margin-top:0">{{$lang('保价费收取标准')}}：</p>
      <table border="1" cellspacing="0" cellpadding="0">
          <tr>
              <td>{{$lang('物品价值')}}</td>
             <td>{{$lang('保价费')}}</td>
          </tr>
          <tr>
              <td>{{$lang('物品价值')}} ≤ 100000KHR</td>
             <td>{{$lang('物品价值')}} * 1%</td>
          </tr>
      </table>
      <p>{{$lang('其他说明')}}：</p>
       <p class="tips-info">
           {{$lang('客户可以选择“保价”服务')}}
       </p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'InsuredStatement',
  data() {
    return {
    }
  },
  props: {
    infoVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideDialog() {
      this.$emit('closeInsured')
    }
  }
}
</script>
<style lang="scss" scoped>
  .tip-box{
    margin-bottom: 40px;
    .tips-info{
      line-height: 20px;
      margin-top: 0;
      margin-bottom: 25px;
    }
  }
  table{
      border-color: #999;
      text-align: center;
      width: 100%;
      td{
          padding: 10px 0;
      }
  }
</style>
